// #standard page 
import React, { Component } from 'react';

//#table
import BootstrapTable from 'react-bootstrap-table-next';
import ToolkitProvider from 'react-bootstrap-table2-toolkit';
import { noDataIndication } from '../../helpers/noDataIndication';
import { dateFormat, currencyFormat } from '../../helpers/formatter';

//#form
import { Card, CardBody } from 'reactstrap';

const dateLabelFormat = (cell, row) => {
    if (row.ReceiptNo) {
        if (row.ReceiptNo.toLowerCase().startsWith('prepaid')) {
            return row.ReceiptNo;
        }
        else {
            return dateFormat(cell);
        }
    }
}


const columns = [
    {
        dataField: 'keyField',
        searchable: false,
        hidden: true
    },
    {
        dataField: 'receiptNo',
        searchable: false,
        hidden: true
    },
    {
        dataField: 'transactionDate',
        text: 'Date',
        formatter: dateLabelFormat
    },
    {
        dataField: 'transactionType',
        text: 'Transaction Type',
    },
    {
        dataField: 'transactionRef',
        text: 'Ref',
    },
    {
        dataField: 'description',
        text: 'Description',
    },
    {
        dataField: 'dr',
        text: 'Dr',
        headerClasses: 'numberColumn',
        classes: 'numberColumn',
        formatter: currencyFormat
    },
    {
        dataField: 'cr',
        text: 'Cr',
        headerClasses: 'numberColumn',
        classes: 'numberColumn',
        formatter: currencyFormat
    },
    {
        dataField: 'balance',
        text: 'Balance',
        headerClasses: 'numberColumn',
        classes: 'numberColumn',
        formatter: currencyFormat
    }
];



class PrepaidCashDetails extends Component {
    constructor(props) {
        super(props);

        this.state = {
            data: this.props.data,
            fromDate: this.props.fromDate,
            toDate: this.props.toDate,
            loading: this.props.loading,
            refresh: this.props.refresh
        };
    }


    componentDidUpdate(prevProps) {
        // refresh data after refresh button clicked 
        // must check props have changed (this.props.refresh !== prevProps.refresh) to avoid infinite loop
        if (this.props.loading !== prevProps.loading) {
            this.setState({
                data: this.props.data,
                loading: this.props.loading,
            });
        };

        // update data when tab changes
        if (this.props.data !== prevProps.data) {
            this.setState({
                data: this.props.data,
            });
        };
    }


    render() {

        const rowClasses = (row) => {
            if (row.ReceiptNo) {
                if (row.ReceiptNo.toLowerCase().startsWith('prepaid')) {
                    return 'font-weight-bold';
                }
            }
        };


        return (
            <React.Fragment>
                <Card className="expand-row">
                    <CardBody>
                        <span className="h5">Prepaid Cash</span>
                        <ToolkitProvider
                            bootstrap4
                            keyField="keyField"
                            data={this.state.data}
                            columns={columns}
                        >
                            {props => (
                                <React.Fragment>
                                    <BootstrapTable
                                        {...props.baseProps}
                                        bordered={false}
                                        rowClasses={rowClasses}
                                        noDataIndication={noDataIndication(this.state.loading)}
                                        hover
                                        wrapperClasses="table-responsive"
                                    />
                                </React.Fragment>
                            )}
                        </ToolkitProvider>
                    </CardBody>
                </Card>
            </React.Fragment>
        );
    }
};


export default PrepaidCashDetails;